module.exports = __webpack_public_path__ + "static/media/overview_high_fives@3x.4e014e5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/footage/others/overview_high_fives@3x.png
// module id = 560
// module chunks = 0